import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { historyQuery } from '../../api/queries';
import { ResultsPage } from '../../features/results/ResultsPage';

// `period` redraws the charts as they were when that period closed (the period slider).
const search = z.object({
  period: z.uuid().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/results')({
  validateSearch: search,
  loader: ({ context }) => context.queryClient.query({ ...historyQuery, staleTime: 'static' }),
  component: function ResultsRoute() {
    const { period } = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <ResultsPage
        viewedPeriodId={period}
        onViewPeriod={(id) => {
          void navigate({ search: id ? { period: id } : {}, replace: true, resetScroll: false });
        }}
      />
    );
  },
});
